var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThryvHeaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 33,
    viewBox: "0 0 81 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0325 26.9158V13.8289C27.9334 11.5002 26.3425 9.77102 24.0873 9.3161C23.0454 9.10686 21.9638 9.04456 20.8974 9.01282C19.2482 8.96462 17.5978 8.99989 15.8624 8.99989V3.28809H11.9941V26.9064H15.909V12.1197C17.8158 12.1197 19.6561 12.0633 21.4906 12.1408C22.6258 12.1902 23.4964 12.8485 23.8274 13.9641C24.0698 14.7834 24.2062 15.665 24.219 16.5208C24.2633 19.7194 24.2365 26.6255 24.2365 26.9158H28.0325ZM34.066 26.9244C34.066 25.7889 34.0508 20.358 34.066 17.183C34.0683 16.5517 34.1348 15.9146 34.221 15.2881C34.4949 13.2815 35.524 12.2893 37.5205 12.1048C38.3224 12.0307 39.1312 12.0213 39.9541 11.9825V9.00378C38.0357 9.03904 36.1464 8.83686 34.2979 9.35526C32.1849 9.94536 30.8084 11.2737 30.404 13.4919C30.263 14.2501 30.1872 15.0283 30.1826 15.7994V26.9244H34.066Z",
    fill: "#121212"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_286_15268",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 10,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.36621H9.78643V26.9442H0V3.36621Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_286_15268)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.35178 23.833C5.35645 23.6473 4.32732 22.6563 4.05226 20.6497C3.96602 20.0232 3.90075 19.3861 3.89725 18.7536C3.89259 17.5029 3.89376 14.8639 3.89725 12.1202H9.68743V9.07919H3.90075C3.90425 6.00288 3.90774 3.42381 3.89725 3.36621H0.0138234C0.00100292 3.57545 -0.00948654 16.6365 0.0138234 20.1384C0.0208163 20.9095 0.095408 21.6889 0.234102 22.4471C0.639694 24.6653 2.01731 25.9924 4.13035 26.5825C5.97883 27.1021 7.86576 26.8976 9.7865 26.934V23.9541C8.96249 23.9165 8.15481 23.9059 7.35178 23.833",
    fill: "#121212"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_286_15268",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 8,
    width: 20,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.8711 8.99512H80.8393V27.1398H61.8711V8.99512Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_286_15268)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.8711 9.01393H65.5436C65.7464 9.01393 66.0296 9.32308 66.1158 9.54408C67.6694 13.6184 71.1659 22.8979 71.3407 23.3175C71.7801 22.4312 75.0493 13.8218 76.6146 9.57699C76.7836 9.1256 76.9934 8.99512 77.4689 8.99512H80.8395C80.7731 9.22552 76.3162 20.1848 74.1542 25.5028C73.7137 26.5878 72.9946 27.1744 71.8151 27.1368C71.5575 27.1274 71.2999 27.125 71.0447 27.1368C69.807 27.1885 69.0552 26.576 68.596 25.4417C66.8979 21.2475 62.4305 10.3869 61.8711 9.01393",
    fill: "#121212"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_286_15268",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 9,
    width: 20,
    height: 24
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0254 9.0459H60.7444V32.7874H41.0254V9.0459Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_286_15268)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1909 32.7763C47.3785 32.7763 48.4671 32.7527 49.558 32.7868C50.0137 32.8009 50.2386 32.6693 50.4368 32.2226C53.7514 24.7616 57.0929 17.3101 60.4274 9.85382C60.5358 9.61402 60.6232 9.36481 60.7444 9.05565C59.5206 9.05565 58.4029 9.07446 57.2852 9.04625C56.8983 9.03802 56.7153 9.17438 56.5626 9.52938C55.6885 11.5736 54.7911 13.6049 53.8983 15.6432C52.8645 18.0001 51.8295 20.3535 50.7514 22.8056C50.4694 22.132 50.22 21.5572 49.9822 20.9777C48.4123 17.1925 46.8505 13.4074 45.2725 9.63048C45.1792 9.40948 44.9508 9.08974 44.7748 9.08386C43.5464 9.03684 42.3179 9.05683 41.0254 9.05683C41.0965 9.25666 41.1303 9.38832 41.1839 9.51175C43.5615 14.8815 45.924 20.2618 48.3412 25.6115C48.7445 26.5096 48.8564 27.2267 48.3587 28.1436C47.5603 29.6153 46.9286 31.1776 46.1909 32.7763",
    fill: "#121212"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_286_15268",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 0,
    width: 61,
    height: 8
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0234 0.210938H80.8384V7.05772H20.0234V0.210938Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_286_15268)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.8401 7.05772L72.9929 3.47007L65.9894 0.265629C65.5955 0.0846008 65.1479 0.374952 65.1479 0.813417V2.8588C65.1479 3.17031 64.909 3.43245 64.6001 3.45714L44.2541 5.1005L20.0234 7.05772H80.8401Z",
    fill: "#FF5000"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.1543 26.2914H77.2289C77.2813 26.2914 77.3209 26.2785 77.3489 26.255C77.3757 26.2279 77.3897 26.1926 77.3897 26.1456C77.3897 26.0927 77.3757 26.0586 77.3501 26.0362C77.3244 26.0174 77.2825 26.0057 77.2265 26.0057H77.1543V26.2914ZM77.5927 26.1409C77.5927 26.2656 77.5379 26.3479 77.4283 26.3926L77.6824 26.823H77.4563L77.25 26.449H77.1533V26.823H76.9505V25.8457H77.2314C77.3561 25.8457 77.447 25.8704 77.5052 25.9198C77.5635 25.9692 77.5927 26.0421 77.5927 26.1409V26.1409ZM76.591 26.3344C76.591 26.4579 76.6213 26.5708 76.6819 26.6754C76.7413 26.7801 76.824 26.8636 76.9289 26.9236C77.0327 26.9847 77.1457 27.0153 77.2658 27.0153C77.387 27.0153 77.5 26.9847 77.6049 26.9224C77.7087 26.8612 77.7914 26.7777 77.8508 26.6731C77.9103 26.5696 77.9406 26.4567 77.9406 26.3344C77.9406 26.2144 77.9103 26.0992 77.8497 25.9933C77.7891 25.8875 77.7063 25.8052 77.6014 25.744C77.4965 25.684 77.3847 25.6535 77.2658 25.6535C77.1457 25.6535 77.0338 25.6829 76.9301 25.7428C76.8275 25.8028 76.7448 25.8851 76.683 25.991C76.6213 26.0968 76.591 26.2121 76.591 26.3344V26.3344ZM76.459 26.3341C76.459 26.1895 76.4939 26.0542 76.5662 25.9284C76.6373 25.8014 76.7352 25.7026 76.8611 25.6309C76.9858 25.5556 77.121 25.5215 77.2655 25.5215C77.4089 25.5215 77.5429 25.5556 77.6676 25.6297C77.7923 25.7002 77.8914 25.799 77.9636 25.926C78.0359 26.0519 78.072 26.1883 78.072 26.3341C78.072 26.4764 78.0371 26.6105 77.9683 26.734C77.8984 26.8598 77.8016 26.9598 77.6758 27.0339C77.5511 27.1091 77.4147 27.1479 77.2655 27.1479C77.1175 27.1479 76.9811 27.1091 76.8553 27.035C76.7305 26.9598 76.6326 26.8598 76.5627 26.7351C76.4939 26.6105 76.459 26.4764 76.459 26.3341V26.3341Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThryvHeaderLogo);
export default __webpack_public_path__ + "static/media/thryv-header-logo.8fe88e5926ad892a266db94734a3858c.svg";
export { ForwardRef as ReactComponent };